export interface ICinemaPhase {
  threshold: number;
  label: string;
  expectedSec: number;
}

export const CINEMA_PHASES: ICinemaPhase[] = [
  { threshold: 0, label: 'Reserving GPU slot', expectedSec: 60 },
  { threshold: 18, label: 'Starting the engine', expectedSec: 4 },
  { threshold: 45, label: 'Polishing the visuals', expectedSec: 4 },
  { threshold: 72, label: 'Connecting your stream', expectedSec: 5 },
  { threshold: 96, label: 'Ready to enter', expectedSec: 1 },
];

export const PHASE_TAIL_SEC = CINEMA_PHASES.map((_, i) =>
  CINEMA_PHASES.slice(i).reduce((total, phase) => total + phase.expectedSec, 0),
);

export const ETA_GLIDE_TAU_SEC = 1.2;
export const ETA_FLOOR_SEC = 5;
export const ETA_IMMINENT_LABEL = 'ready any moment now';

export const SEGMENT_GAP_PX = 5;
export const TIP_ROTATE_MS = 6000;
export const TIP_FADE_MS = 350;
export const STEP_FADE_MS = 180;
export const AUTO_ENTER_CTA_DELAY_MS = 1500;

export const MAX_FRAME_DELTA_SEC = 0.1;
export const CATCHUP_RATE_PER_SEC = 2.2;
export const CATCHUP_FLOOR_PER_SEC = 2;
export const MIN_PHASE_TAU_SEC = 4;
export const FINISH_MS_PER_PERCENT = 9;
export const FINISH_MIN_MS = 260;
export const FINISH_MAX_MS = 700;
export const COMPLETE_HOLD_MS = 350;

export interface ICinemaTip {
  before?: string;
  strong: string;
  after?: string;
}

export const CINEMA_TIPS: ICinemaTip[] = [
  {
    before: 'Press ',
    strong: 'F',
    after: ' to toggle fullscreen once you’re inside',
  },
  {
    strong: 'WASD',
    after: ' to move · hold right mouse button to look around',
  },
  {
    before: 'Use ',
    strong: 'headphones',
    after: ' — audio in the space is spatial',
  },
  {
    before: 'Your mic starts ',
    strong: 'muted',
    after: ' — hold V to talk',
  },
  {
    before: 'Press ',
    strong: 'M',
    after: ' to open the map from anywhere',
  },
  {
    before: 'Click a teammate’s ',
    strong: 'avatar',
    after: ' to start a private voice chat',
  },
  {
    strong: 'Share your screen',
    after: ' to any media wall from the toolbar',
  },
  {
    before: 'Invite teammates with a ',
    strong: 'single link',
    after: ' — nothing to install',
  },
  {
    before: 'Press ',
    strong: 'Esc',
    after: ' to tune video quality and controls',
  },
  {
    before: 'Lost? Press ',
    strong: 'H',
    after: ' to teleport back to the hub',
  },
];

export const CINEMA_FONTS_LINK_ID = 'myta-cinema-fonts';
export const CINEMA_FONTS_URL =
  'https://fonts.googleapis.com/css2?family=Space+Grotesk:wght@500;600;700&family=Inter:wght@400;500;600&family=JetBrains+Mono:wght@400;500;600&display=swap';

export const LOADING_HEADLINE = 'Loading your experience';
export const READY_HEADLINE = 'Your experience is ready';
export const KEEP_TAB_HINT =
  'Keep this tab open — we’ll take you in automatically the moment everything is ready.';
